/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PatientMedicineNotebook,
  PatientMedicineNotebookFromJSON,
  PatientMedicineNotebookFromJSONTyped,
  PatientMedicineNotebookToJSON,
} from "./";

export const PutMedicineNotebookResponseTypename = "PutMedicineNotebookResponse" as const;

/**
 *
 * @export
 * @interface PutMedicineNotebookResponse
 */
export interface PutMedicineNotebookResponse {
  /**
   *
   * @type {PatientMedicineNotebook}
   * @memberof PutMedicineNotebookResponse
   */
  medicineNotebook?: PatientMedicineNotebook;
  /**
   * Resource type name
   * @type {string}
   * @memberof PutMedicineNotebookResponse
   */
  readonly __typename?: string;
}

export function PutMedicineNotebookResponseFromJSON(json: any): PutMedicineNotebookResponse {
  return PutMedicineNotebookResponseFromJSONTyped(json, false);
}

export function PutMedicineNotebookResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PutMedicineNotebookResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PutMedicineNotebookResponseTypename,

    medicineNotebook: !exists(json, "medicine_notebook")
      ? undefined
      : PatientMedicineNotebookFromJSON(json["medicine_notebook"]),
  };
}

export function PutMedicineNotebookResponseToJSON(object?: PutMedicineNotebookResponse | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    medicine_notebook: PatientMedicineNotebookToJSON(value.medicineNotebook),
  };
}
